import { RouteRecordRaw } from "vue-router";
import ServiceManagement from "@/views/playground/planner/business-management/service-management/ServiceManagement.vue";
import CustomerManagement from "@/views/playground/planner/business-management/customer-management/CustomerManagement.vue";
import SettlementManagement from "@/views/playground/planner/business-management/settlement-management/SettlementManagement.vue";
import ReviewManagement from "@/views/playground/planner/business-management/review-management/ReviewManagement.vue";
import Statistics from "@/views/playground/planner/business-management/statistics/Statistics.vue";
import serviceRoutes from "@/router/playground/planner/business/service";
import customerRoutes from "@/router/playground/planner/business/customer";
import settlementRoutes from "@/router/playground/planner/business/settlement";
import statisticsRoutes from "@/router/playground/planner/business/statistics";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    redirect: (to) => `/playground/${to.meta.role}/business/service`,
  },
  {
    path: "service",
    component: ServiceManagement,
    children: serviceRoutes,
  },
  {
    path: "customer",
    component: CustomerManagement,
    children: customerRoutes,
  },
  {
    path: "settlement",
    component: SettlementManagement,
    children: settlementRoutes,
  },
  {
    path: "review",
    component: ReviewManagement,
  },
  {
    path: "statistics",
    component: Statistics,
    children: statisticsRoutes,
  },
];

export default routes;
